export enum PlanInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  QUARTER = 'quarter',
  HALFYEAR = 'halfyear',
  YEAR = 'year',
  LIFETIME = 'lifetime',
}

export type SubscriptionPlanConfig = {
  flexPriceId?: string
  interval?: PlanInterval
  paddlePriceId?: string
  stripePriceId?: string
  stripeDiscountId?: string
  sku?: string
}
